// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { DemographicsBaseService } from './demographics-base.service';
import { DemographicModel, DemographicValueModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class DemographicsMockService extends DemographicsBaseService {
  constructor() {
    super();
  }

  loadDemographics(useCache: boolean): void {
    this._demographics$.next(this.makeUpDemographicsForTestingPurposes());
  }

  private makeUpDemographicsForTestingPurposes(): DemographicModel[] {
    const result = new Array<DemographicModel>();

    let values = [
      {id: 'v1', demographicId: '1', name: '1971', index: 1 },
      {id: 'v2', demographicId: '1', name: '1972', index: 2 },
      {id: 'v3', demographicId: '1', name: '1973', index: 3 },
      {id: 'v4', demographicId: '1', name: '1974', index: 4 },
      {id: 'v5', demographicId: '1', name: '1975', index: 5 }
    ] as DemographicValueModel[];
    let demo = new DemographicModel('1', 'Year of Birth', true, values, 'yearOfBirth');
    result.push(demo);

    values = [
      {id: 'v10', demographicId: '2', name: 'Kiribati', index: 1 },
      {id: 'v11', demographicId: '2', name: 'Kyrgyzstan', index: 2 },
      {id: 'v12', demographicId: '2', name: 'Mars, the Free Republic of', index: 3 },
      {id: 'v13', demographicId: '2', name: 'South Africa', index: 4 },
      {id: 'v14', demographicId: '2', name: 'Yoggoth', index: 5 },
    ] as DemographicValueModel[];
    demo = new DemographicModel('2', 'Country', true, values, 'country');
    result.push(demo);

    values = [
      {id: 'v6', demographicId: '3', name: 'Male', index: 1 },
      {id: 'v7', demographicId: '3', name: 'Female', index: 2 },
      {id: 'v8', demographicId: '3', name: 'Other', index: 3 },
      {id: 'v9', demographicId: '3', name: 'Prefer not to say', index: 4 },
    ] as DemographicValueModel[];
    demo = new DemographicModel('3', 'Gender', false, values, 'gender');
    result.push(demo);

    values = [
      {id: 'v15', demographicId: '4', name: 'Employed', index: 1 },
      {id: 'v16', demographicId: '4', name: 'Self-employed', index: 2 },
      {id: 'v17', demographicId: '4', name: 'Student', index: 3 },
      {id: 'v18', demographicId: '4', name: 'Volunteer', index: 4 },
      {id: 'v19', demographicId: '4', name: 'Unemployed', index: 5 },
      {id: 'v20', demographicId: '4', name: 'Prefer not to say', index: 6 },
    ] as DemographicValueModel[];
    demo = new DemographicModel('4', 'Occupational Status', false, values, 'occupationalStatus');
    result.push(demo);

    return result;
  }
}
